import React from "react";
import "./Team_personal_page.css";

const Team_personal_page = () => {
  return (
    <div className="text_team">
      <h2>Supervisors</h2>
      <br></br>

      <div className="photo-container">
        <div className="photo-item"></div>

        <div className="photo-item">
          <img
            src={"https://static.igem.wiki/teams/4888/wiki/brian.jpg"}
            alt="Brian McCabe"
          />
          <div className="image-text">
            <h3>Brian McCabe</h3>
            <p className="gray-text"> Professor at EPFL </p>
            <p>Principal investigator and team motivator</p>
          </div>
        </div>
        <div className="photo-item"></div>

        <div className="photo-container">
          <div className="photo-item">
            <img
              src={"https://static.igem.wiki/teams/4888/wiki/rebecca.jpg"}
              alt="Rebecca Smith"
            />
            <div className="image-text">
              <h3>Rebecca Smith</h3>
              <p className="gray-text"> PhD at EPFL </p>
              <p>Principal teaching assistant, coordinator for the team</p>
            </div>
          </div>

          <div className="photo-item">
            <img
              src={"https://static.igem.wiki/teams/4888/wiki/pickeshav.jpg"}
              alt="Keshav Jha"
            />
            <div className="image-text">
              <h3>Keshav Jha</h3>
              <p className="gray-text"> PhD at EPFL </p>
              <p>Teaching assistant, coordinator of wet lab</p>
            </div>
          </div>

          <div className="photo-item">
            <img
              src={"https://static.igem.wiki/teams/4888/wiki/hannah.jpg"}
              alt="Hannah Schede"
            />
            <div className="image-text">
              <h3>Hannah Schede</h3>
              <p className="gray-text"> PhD at EPFL </p>
              <p>Teaching assistant, coordinator of dry lab</p>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Team_personal_page;
